const FORMS = {
  fact_find_personal_details: "221304733573047",
  fact_find_financial_details: "221304082667048",
  fact_find_risk_reward: "221304462979056",
  business_details: "233033730121035",
  qualification: "233395287682065",
  // "eligibility": "221163453792052",
  // "contribution": "221163289981059",
  // "employment":"221163481377052",
};
export default function getFormId(form_name: any) {
  return FORMS[form_name as keyof typeof FORMS];
}
